
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/activity/reward-hub",
      function () {
        return require("private-next-pages/activity/reward-hub.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/activity/reward-hub"])
      });
    }
  